// The 9 default ion colors, any colors not listed here will not be supported if added to the client config.
export const DEFAULT_ION_COLORS = [
	'primary',
	'secondary',
	'tertiary',
	'success',
	'warning',
	'danger',
	'dark',
	'medium',
	'light'
] as const;

// The different variants for each default color
export const DEFAULT_ION_COLORS_VARIANTS = ['rgb', 'contrast', 'contrast-rgb', 'shade', 'tint'] as const;

export type IonColor = (typeof DEFAULT_ION_COLORS)[number];
export type IonColorVariant = (typeof DEFAULT_ION_COLORS_VARIANTS)[number];
